import { hbbTvMode, Mode, tizenMode, webOsMode } from '../../common/types';
import { HbbTVExit } from '../hbbtv';
import { tizenExit } from '../tizen';
import { webOsExit } from '../webos';

export default function closeAppByMode(mode: Mode) {
  switch (mode) {
    case hbbTvMode:
      HbbTVExit();
      break;
    case webOsMode:
      webOsExit();
      break;
    case tizenMode:
      tizenExit();
      break;
    default:
      window.close();
      break;
  }
}
